import React from 'react';
import {
  Box, Container, Typography, Grid, Stack, Button, Card, CardContent,
} from '@mui/material';
import { Check, ArrowForward } from '@mui/icons-material';
import { C, Section } from './theme';

const migrationItems = [
  'Zero downtime during transfer',
  'Preserves all content, themes, and plugins',
  'Includes free domain transfer if needed',
  'Expert support available throughout the process',
];

const VpsMigration = () => (
  <Section id="migration" sx={{ background: '#FFFFFF', borderBottom: `1px solid ${C.border}` }}>
    <Container maxWidth="lg">
      {/* MUI v6 Grid size */}
      <Grid container spacing={{ xs: 4, md: 5 }}>

        {/* Left Box: VPS migration */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Card elevation={0} sx={{
            border: `1px solid ${C.border}`,
            borderRadius: '16px',
            p: { xs: 3.5, md: 4.5 },
            background: C.bgSection,
            height: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
          }}>
            <Box>
              <Typography sx={{ color: C.primary, fontWeight: 800, fontSize: '0.78rem', letterSpacing: '0.12em', textTransform: 'uppercase', mb: 1.5 }}>
                MIGRATION ASSISTANCE
              </Typography>
              <Typography variant="h3" sx={{ fontWeight: 800, fontSize: { xs: '1.6rem', md: '2rem' }, color: C.textPrimary, mb: 3, letterSpacing: '-0.02em' }}>
                VPS migration available through our team
              </Typography>

              <Stack spacing={2} sx={{ mb: 4 }}>
                {migrationItems.map((item) => (
                  <Stack key={item} direction="row" spacing={1.5} alignItems="center">
                    <Box sx={{
                      width: 22, height: 22, borderRadius: '50%',
                      background: C.successLight, display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0,
                    }}>
                      <Check sx={{ color: C.success, fontSize: 14 }} />
                    </Box>
                    <Typography sx={{ color: C.textPrimary, fontWeight: 600, fontSize: '0.92rem' }}>
                      {item}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>

            <Button variant="contained" size="large" sx={{
              background: C.primary, color: '#FFFFFF', fontWeight: 700, textTransform: 'none',
              borderRadius: '8px', px: 3, py: 1.25, width: 'fit-content', boxShadow: 'none',
              '&:hover': { background: C.primaryHover, boxShadow: 'none' },
            }}>
              Request Free Migration
            </Button>
          </Card>
        </Grid>

        {/* Right Box: Case Study */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Card elevation={0} sx={{
            border: `1px solid ${C.primary}30`,
            borderRadius: '16px',
            p: { xs: 3.5, md: 4.5 },
            background: C.primaryLight,
            height: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
          }}>
            <Box>
              <Typography sx={{ color: C.primary, fontWeight: 800, fontSize: '0.78rem', letterSpacing: '0.12em', textTransform: 'uppercase', mb: 1.5 }}>
                CUSTOMER STORY
              </Typography>
              <Typography variant="h3" sx={{ fontWeight: 800, fontSize: { xs: '1.6rem', md: '2rem' }, color: C.textPrimary, mb: 2, letterSpacing: '-0.02em' }}>
                How she uses Hosting Services to scoop up sales
              </Typography>
              <Typography sx={{ color: C.textSecondary, fontSize: '0.95rem', lineHeight: 1.65, mb: 4 }}>
                Discover how Scoops of Favor uses Hosting Services to sell high-quality, lactose-free ice cream locally.
                Our high-speed VPS hosting provided smooth online store performance during busy flash sales.
              </Typography>
            </Box>

            <Button variant="outlined" endIcon={<ArrowForward />} sx={{
              borderColor: C.primary, color: C.primary, fontWeight: 700, textTransform: 'none',
              borderRadius: '8px', px: 3, py: 1.25, width: 'fit-content', background: '#FFFFFF',
              '&:hover': { background: C.primaryLight, borderColor: C.primaryHover },
            }}>
              Read Customer Story
            </Button>
          </Card>
        </Grid>

      </Grid>
    </Container>
  </Section>
);

export default VpsMigration;
